export class DashboardAmountOfSalesModel {
    value:number = 0
    date:Date|string|null = null

    constructor(d?:Partial<DashboardAmountOfSalesModel>) {
        Object.assign(this, d)
    }
}
